import { render, staticRenderFns } from "./SvgIconGen.vue?vue&type=template&id=3b818d80&"
import script from "./SvgIconGen.vue?vue&type=script&lang=js&"
export * from "./SvgIconGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports